module.exports = "<h1 class=\"big-text\">404</h1>\n<h2>Nothing found here! Try <a routerLink=\"/posts\">Home page</a></h2>\n"